import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

/**
 * Shared raw/adjusted toggle — reuses the ToggleButtonGroup pattern already
 * established for Analysis.jsx's attribution toggle. Wire `value`/`onChange`
 * to whichever adjustment mechanism the page uses (win-rate regression AME,
 * baseline-comparison cohort, etc.) — this component only renders the control.
 */
export default function RawAdjustedToggle({
  value,
  onChange,
  adjustedLabel = 'Adjusted',
  rawLabel = 'Raw',
  ariaLabel = 'raw or adjusted view',
  size = 'small',
}) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, v) => { e.stopPropagation(); if (v) onChange(v); }}
      onClick={(e) => e.stopPropagation()}
      size={size}
      aria-label={ariaLabel}
    >
      <ToggleButton value="adjusted" sx={{ fontSize: '0.65rem', px: 1, py: 0.25 }}>{adjustedLabel}</ToggleButton>
      <ToggleButton value="raw" sx={{ fontSize: '0.65rem', px: 1, py: 0.25 }}>{rawLabel}</ToggleButton>
    </ToggleButtonGroup>
  );
}
